var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ../node_modules/lodash/_Uint8Array.js
// module id = 617
// module chunks = 1